import { useState, useEffect } from 'react';

import { INavMenuProps } from 'interfaces/PreviewScreen/previewScreen';
import InfoImg from 'public/assets/info.svg';
import MoreImg from 'public/assets/more.svg';
import SettingImg from 'public/assets/SettingIcon.svg';
import ChatImg from 'public/assets/Vector.svg';

import NavMenuItem from './FileNav';

const NavMenu = ({
  isMediaMax1025px,
  setActive,
  active,
  canUserEdit,
  signalNewMessage,
  setSignalNewMessage,
  userMessages,
}: INavMenuProps) => {
  const [lastMessageRecievedAt, setLastMessageRecievedAt] = useState(-1);
  useEffect(() => {
    const lastMessageTime = userMessages[userMessages.length - 1]?.createdAt;
    if (lastMessageRecievedAt !== lastMessageTime) {
      if (lastMessageRecievedAt !== -1) {
        setSignalNewMessage(true);
      }
      setLastMessageRecievedAt(lastMessageTime);
    }
  });
  return (
    <div
      className={`p-2 ${
        isMediaMax1025px ? '' : 'h-[10vh]'
      }  bg-white  relative flex items-center   rounded-md`}
    >
      <div className="flex h-full w-full overflow-x-auto no-scrollbar justify-start">
        {isMediaMax1025px && (
          <NavMenuItem
            isMediaMax1025px={isMediaMax1025px}
            setActive={setActive}
            image={{ main: InfoImg.src }}
            navName={'File'}
            active={active}
            setSignalNewMessage={setSignalNewMessage}
          />
        )}
        {/* About tab */}
        <NavMenuItem
          isMediaMax1025px={isMediaMax1025px}
          setActive={setActive}
          image={{ main: InfoImg.src }}
          navName={'About'}
          active={active}
          setSignalNewMessage={setSignalNewMessage}
        />
        {/* Chat tab */}
        <NavMenuItem
          isMediaMax1025px={isMediaMax1025px}
          setActive={setActive}
          image={{ main: ChatImg.src }}
          navName={'Chat'}
          active={active}
          signalNewMessage={signalNewMessage}
          setSignalNewMessage={setSignalNewMessage}
        />
        {!canUserEdit ? (
          <div
            onClick={() => {
              if (active === 'Chat') {
                setSignalNewMessage(false);
              }
              setActive('More');
            }}
            className={` ${
              active === 'More' ? 'bg-yellow' : 'bg-white border border-black'
            } flex w-[100px]  p-3 rounded-lg items-center justify-center cursor-pointer`}
          >
            <img className="" src={MoreImg.src} alt="" />
          </div>
        ) : (
          <div
            onClick={() => {
              if (active === 'Chat') {
                setSignalNewMessage(false);
              }
              setActive('Setting');
            }}
            className={` ${
              active === 'Setting'
                ? 'bg-yellow'
                : 'bg-white border border-black'
            } flex w-[100px] p-4 rounded-lg items-center justify-center cursor-pointer`}
          >
            <img className="" src={SettingImg.src} alt="" />
          </div>
        )}
        {/* More tab */}
      </div>
    </div>
  );
};
export default NavMenu;
